import React, { useEffect, useState } from 'react';
import { Progress, Card, Row, Col, Spin,Button } from 'antd'; // Import Spin for the loading indicator
import { PlusCircleOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { getMsisdnDetails } from '../api/api'; // Import the new function

// Default icon URL
const defaultIconUrl = '/card-triangles.png';

// Color list
const colors = ['#652D86', '#F7941E', '#FDB934', '#F16522', '#882C62', '#C40D42', '#EE3E80', '#BEB1D7'];

const BeemaPlans = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const msisdn = queryParams.has('MSISDN') ? decodeURIComponent(queryParams.get('MSISDN')) : null;
  const [plans, setPlans] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true); // New state for loading

  useEffect(() => {
    if (!msisdn) {
      setError(true);
      setLoading(false);
      return;
    }
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const [response, error] = await getMsisdnDetails(msisdn); // Use the new function
        if (error) {
          console.error('Error fetching plans:', error);
          setError(true);
          return;
        }        

        if (response.data.products && response.data.products.length > 0) {
          const products = response.data.products.map((product, index) => {
            const startDate = new Date(product.startDate);
            const expiryDate = new Date(product.expiryDate);
            const totalDays = (expiryDate - startDate) / (1000 * 60 * 60 * 24);

            const currentDate = new Date();
            const remainingDays = Math.ceil((expiryDate - currentDate) / (1000 * 60 * 60 * 24));

            const progress = 100 - (((product.productPeriod - remainingDays) / product.productPeriod) * 100);

            return {
              title: product.productName,
              coverage: product.productDescription || 'No description available',
              duration: `${totalDays}D`,
              iconUrl: product.productIcon || defaultIconUrl,
              progress: Math.max(0, Math.min(100, progress)),
              color: colors[index % colors.length],
              remainingDays: remainingDays > 0 ? remainingDays : 0,
            };
          });

          setPlans(products);
          setError(false);
        } else {
          setError(true);
        }
      } catch (error) {
        console.error('Error fetching plans:', error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (msisdn) {
      fetchPlans();
    }
  }, [msisdn]);

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', background: '#fff', padding: '20px', fontFamily: 'Quicksand, sans-serif', height: '100vh', overflow: 'auto'}}>
      <h1 style={{ color: '#5E2AB3', fontSize: '24px', fontWeight: 'bold' }}>Beema , Sadhain ON</h1>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
          <Spin size="large" />
        </div>
      ) : (
        <p style={{ color: '#000'}}>
        {error ? (
          msisdn ? (
            <>
              You haven't activated any Beema pack. To buy a Beema pack, click buy button below.    
              <div style={{ height: '40px' }} /> {/* Add space equivalent to two lines */}
              <div style={{ display: 'flex', justifyContent: 'center' }}> {/* Center-align the button */}
                <Button 
                  type="primary"
                  shape="round"
                  icon={<PlusCircleOutlined />} 
                  onClick={() => window.open("https://ncellssa.page.link/dGQxtjkzvJ54GdXb8", "_blank")} 
                  style={{ display: 'flex', alignItems: 'center', marginLeft: '5px' }}
                >
                  Buy Packs
                </Button>
              </div>
            </>
          ) : (
            "MSISDN is not provided. Please provide MSISDN to view the insurance details."
          )
        ) : (
          "The Beema packs that are activated are below."
        )}
      </p>
      )}
      {!loading && plans.map((plan, index) => (
        <div key={index}>
          <h2 style={{ color: '#5E2AB3', fontSize: '20px', fontWeight: 'bold' }}>{plan.title}</h2>
          <Card style={{ marginBottom: '20px', borderRadius: '10px', borderColor: '#f0f0f0' }}>
            <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'nowrap' }}>
              <Col xs={24} sm={8} md={6} style={{ position: 'relative', flex: '0 0 auto' }}>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <div style={{ 
                    backgroundColor: plan.color, 
                    borderRadius: '10px', 
                    height: '112px', 
                    width: '112px',
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    paddingRight: '40px'
                  }}>
                    <img 
                      src={plan.iconUrl || defaultIconUrl} 
                      alt={plan.title} 
                      style={{ width: '48px'}} 
                    />
                  </div>
                  <div style={{ 
                    textAlign: 'center', 
                    color: '#fff', 
                    backgroundColor: '#00000033', 
                    padding: '4px 0', 
                    borderRadius: '0 10px 10px 0', 
                    position: 'absolute', 
                    right: '0', 
                    top: '0', 
                    height: '112px', 
                    width: '40px',
                    display: 'flex', 
                    alignItems: 'center',
                    justifyContent: 'center', 
                    fontWeight: 600 
                  }}>
                    {plan.duration}
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={16} md={18} style={{ flex: '1 1 auto', fontWeight: 600 }}>
                <p style={{ fontWeight: 600}} >{plan.coverage}</p>
                <Progress percent={plan.progress} showInfo={false} strokeColor={plan.color} />
                <p style={{ color: '#faad14', fontWeight: 'bold' }}>{plan.remainingDays} Days Remaining</p>
              </Col>
            </Row>
          </Card>
        </div>
      ))}
      {!loading && plans.length > 0 && plans.length < 5 && (
        <div style={{ textAlign: 'center', marginTop: '20px', fontWeight: 600 }}>
          To buy other Beema packs click
          <a href="https://ncellssa.page.link/dGQxtjkzvJ54GdXb8" target="_blank" rel="noopener noreferrer">
            &nbsp;here
          </a>
          .
        </div>
      )}
    </div>
  );
};

export default BeemaPlans;